import { Sun, Moon, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/auth-context.tsx';
import { useTheme } from '../../contexts/theme-context.tsx';
import { Button } from '../../components/ui/button.tsx';

export function SettingsPage(): JSX.Element {
  const { state, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const userEmail = state.kind === 'authenticated' ? state.user.email : '';

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">Настройки</h1>
        <p className="text-sm text-fg-muted">Аккаунт и предпочтения</p>
      </div>

      <div className="space-y-4">
        <Section title="Аккаунт">
          <Row label="Email" value={userEmail} />
          <Row label="Роль" value={state.kind === 'authenticated' ? state.user.role : ''} />
        </Section>

        <Section title="Внешний вид">
          <div className="flex items-center justify-between">
            <span className="text-sm">Тема</span>
            <Button variant="secondary" onClick={toggle}>
              {theme === 'dark' ? (
                <>
                  <Sun className="h-4 w-4" />
                  Переключить на светлую
                </>
              ) : (
                <>
                  <Moon className="h-4 w-4" />
                  Переключить на тёмную
                </>
              )}
            </Button>
          </div>
        </Section>

        <Section title="Сессия">
          <div className="flex items-center justify-between">
            <span className="text-sm text-fg-muted">
              Завершить текущую сессию на этом устройстве
            </span>
            <Button variant="danger" onClick={() => void logout()}>
              <LogOut className="h-4 w-4" />
              Выйти
            </Button>
          </div>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <div className="rounded-lg border border-border bg-bg-soft p-5">
      <h2 className="mb-4 text-sm font-medium uppercase tracking-wider text-fg-muted">{title}</h2>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: string }): JSX.Element {
  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-fg-muted">{label}</span>
      <span className="font-mono">{value || '—'}</span>
    </div>
  );
}
